// ----------------------------------------------------------------------------
// Snippet: OOS Notification Modal
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/_containers/modal/modal';

// Styles
import './_oos-notification.scss';
import {closeModal} from 'snippets/_containers/modal/modal';

const KLAVIYO_BASE_URL = 'https://a.klaviyo.com/client';
const BACK_IN_STOCK_ROUTE = 'back-in-stock-subscriptions';
const SUBSCRIPTION_ROUTE = 'subscriptions';
const COMPANY_ID_PARAM = '?company_id=TnRWte';
const MARKETING_LIST_ID = 'XRdMbm';

async function optInToOOSNotification() {
    const modal = document.querySelector('.modal--oos-notification');
    if (modal) {
        const form = modal.querySelector('form');
        const validForm = form.checkValidity();
        if(!validForm) {
            return;
        }

        const variantId = modal.getAttribute('data-variant-id');
        const email = modal.querySelector('input[type="email"]').value;
        const marketingOptIn = modal.querySelector('input[type="checkbox"]').checked;

        const payload = createBackInStockRequestPayload(email, variantId);
        const requestOptions = createRequestOptions(payload);
        await fetch(`${KLAVIYO_BASE_URL}/${BACK_IN_STOCK_ROUTE}/${COMPANY_ID_PARAM}`, requestOptions)
            .then(async () => {
                if(marketingOptIn) {
                    await optInToMarketingEmails(email);
                }
                modal.querySelector('.oos-notification__message.success').style.display = 'block';
                modal.querySelector('.oos-notification__message.success a').addEventListener('click', () => {
                    closeModal();
                });
            })
            .catch(() => modal.querySelector('.oos-notification__message.error').style.display = 'block');
    }
}

async function optInToMarketingEmails(email) {
    const payload = createMarketingOptInRequestPayload(email);
    const requestOptions = createRequestOptions(payload);

    await fetch(`${KLAVIYO_BASE_URL}/${SUBSCRIPTION_ROUTE}/${COMPANY_ID_PARAM}`, requestOptions)
        .catch(error => console.log('Error subscribing to email marketing: ', error));
}

function createBackInStockRequestPayload(email, variantId) {
    return {
        data: {
            type: 'back-in-stock-subscription',
            attributes: {
                channels: ['EMAIL'],
                profile: {
                    data: {
                        type: 'profile',
                        attributes: {
                            email,
                        }
                    }
                }
            },
            relationships: {
                variant: {
                    data: {
                        type: 'catalog-variant',
                        id: `$shopify:::$default:::${variantId}`
                    }
                }
            }
        }
    };
}

function createMarketingOptInRequestPayload(email) {
    return {
        data: {
            type: 'subscription',
            attributes: {
                profile: {
                    data: {
                        type: 'profile',
                        attributes: {
                            email,
                        },
                    }
                }
            },
            relationships: {list: {data: {type: 'list', id: MARKETING_LIST_ID}}}
        }
    };
}

function createRequestOptions(payload) {
    return {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'revision':'2024-05-15'
        },
        body: JSON.stringify(payload),
    };
}

window.addEventListener('open.modal', () => {
    const oosModalButton = document.querySelector('.oos-notification-submit');
    if(oosModalButton) {
        oosModalButton.parentElement.addEventListener('submit', (e) => {
            e.preventDefault();
        });
        oosModalButton.addEventListener('click', optInToOOSNotification);
    }
});

